import { SubscriptionHookOptions, useSubscription } from "@apollo/client";

import { ExpertActivitiesDocument, ExpertActivitiesSubscription } from "@typing/Generated";

const useSubscribeToExpertActivities = (
  expertId: string | null | undefined,
  onUpdate?: () => void,
  options?: SubscriptionHookOptions<ExpertActivitiesSubscription>
) => {
  useSubscription<ExpertActivitiesSubscription>(ExpertActivitiesDocument, {
    ...options,
    onData: data => {
      if (data.data.data?.expertActivities?.activity && onUpdate) {
        onUpdate();
      }
    },
    skip: !expertId,
    variables: { expertId }
  });
};

export default useSubscribeToExpertActivities;
